import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ----- Auth ---------------------------------------------------------------
export async function authMe() {
  const r = await api.get("/auth/me");
  return r.data;
}
export async function authLogin(email, password) {
  const r = await api.post("/auth/login", { email, password });
  return r.data;
}
export async function authLogout() {
  await api.post("/auth/logout");
}

// ----- Admin --------------------------------------------------------------
export async function adminListUsers() {
  const r = await api.get("/admin/users");
  return r.data;
}
export async function adminCreateUser(body) {
  const r = await api.post("/admin/users", body);
  return r.data;
}
export async function adminPatchUser(id, patch) {
  const r = await api.patch(`/admin/users/${id}`, patch);
  return r.data;
}
export async function adminDeleteUser(id) {
  await api.delete(`/admin/users/${id}`);
}

// ----- Projects -----------------------------------------------------------
export async function listProjects() {
  const r = await api.get("/projects");
  return r.data;
}
export async function createProject(payload) {
  const r = await api.post("/projects", payload);
  return r.data;
}
export async function getProject(id) {
  const r = await api.get(`/projects/${id}`);
  return r.data;
}
export async function updateProject(id, payload) {
  const r = await api.patch(`/projects/${id}`, payload);
  return r.data;
}
export async function deleteProject(id) {
  await api.delete(`/projects/${id}`);
}

/**
 * Format an arbitrary FastAPI `detail` field into a display-safe string.
 * FastAPI's 422 validation errors return an ARRAY of `{msg,...}` objects — if
 * you setState() that array or drop it into JSX, React crashes. Always run
 * every error payload through this before setting error state.
 */
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
